// 新人注册
const newUserZone = () => import('@/pages/newUserRegister/newUserZone.vue');
const newUservideo = () => import('@/pages/newUserRegister/newUservideo.vue');
const newZone = () => import('@/pages/newUserRegister/newZone.vue');
export default [
  {
    path: '/newUserZone',
    component: newUserZone,
    meta: {
      title: '新人专区',
    },
  },
  {
    path: '/newUservideo',
    component: newUservideo,
    meta: {
      title: '新人专区',
    },
  },
  {
    path: '/newZone',
    component: newZone,
    meta: {
      title: '新人专区',
    },
  },
];
